// AIM-run duration formatting.
//
// Runs are documented at ~9 minutes; anything past 24h is treated as a
// stuck/orphan run. The threshold for switching the unit from "hours" to
// "days" was bumped from 48h → 24h (markup #76 / #77) so the column
// never mixes "34.6 hours" against neighbors that read in days.

export const ABSURD_DURATION_SECONDS = 86400; // 24h — stuck-run threshold

export function fmtDuration(seconds) {
  if (seconds == null) return '—';
  const total = Number(seconds);
  if (!Number.isFinite(total) || total < 0) return '—';
  if (total < 60) return `${Math.floor(total)}s`;
  if (total < 3600) {
    const m = Math.floor(total / 60);
    return `${m}m ${Math.round(total % 60)}s`;
  }
  if (total < ABSURD_DURATION_SECONDS) return `${(total / 3600).toFixed(1)} hours`;
  return `${(total / 86400).toFixed(1)} days`;
}

export function isAbsurdDuration(seconds) {
  const total = Number(seconds);
  return Number.isFinite(total) && total > ABSURD_DURATION_SECONDS;
}

// Latency formatter for sub-minute durations measured in milliseconds.
// Raw ms reads poorly past ~1s ("9594ms" is harder to parse than "9.6s"),
// so anything >=1000ms flips to a seconds-with-one-decimal form. The
// returned string always includes its unit so the consumer renders it
// verbatim — no extra suffix concatenation.
export function fmtLatency(ms) {
  const n = Number(ms);
  if (ms == null || !Number.isFinite(n) || n < 0) return '—';
  if (n < 1000) return `${Math.round(n)}ms`;
  return `${(n / 1000).toFixed(1)}s`;
}
